import type { IConnection } from "@nestia/fetcher";
import { config } from "../config/app";

const setToken = (token: string): void => {
  window.localStorage.setItem(config.LS.TOKEN, token);
};

const revokeToken = (): void => window.localStorage.removeItem(config.LS.TOKEN);

const getToken = (): string | null =>
  window.localStorage.getItem(config.LS.TOKEN);

const setCompanyHeader = (id: number): void => {
  window.localStorage.setItem(config.LS.ACTIVE_COMPANY_ID, id.toString());
};

const removeCompanyHeader = (): void => {
  window.localStorage.removeItem(config.LS.ACTIVE_COMPANY_ID);
};

const getConnection = (): IConnection => {
  const token = getToken();
  const activeCompanyId = window.localStorage.getItem(
    config.LS.ACTIVE_COMPANY_ID,
  );
  return {
    host: config.API_ORIGIN,
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(activeCompanyId && {
        [config.HEADERS.ACTIVE_COMPANY_ID]: activeCompanyId,
      }),
    },
  };
};

export {
  getConnection,
  setToken,
  revokeToken,
  getToken,
  setCompanyHeader,
  removeCompanyHeader,
};
